import { toTitleCase } from './toTitleCase';

export const getPolicyStreamFormLabelFromInternalName = (
  internalName: string,
) => {
  const matchesApplication = internalName.match(/^application_(.+)/i);
  if (matchesApplication) {
    const other = matchesApplication[1];
    if (other === 'rbc') {
      return 'RBC Application';
    }
    return toTitleCase(`${other} Application`);
  } else if (internalName.match(/^basic_info/i)) {
    return 'Basic Information';
  } else if (internalName.match(/^basic_client_info/i)) {
    return 'Basic Client Information';
  }
  return toTitleCase(internalName.split('_').join(' '));
};

export const getPolicyStreamFormLabel = (
  form: { form?: { internalName?: string } } | { internalName?: string },
) => {
  if ('internalName' in form && form.internalName) {
    return getPolicyStreamFormLabelFromInternalName(form.internalName);
  } else if ('form' in form && form.form?.internalName) {
    return getPolicyStreamFormLabelFromInternalName(form.form.internalName);
  }
  return 'Unknown';
};

export const getCompletedFormDisplayLabel = (form: {
  internalName?: string;
  policy?: null | { displayName: string };
}) => {
  if (form.internalName) {
    return getPolicyStreamFormLabel(form);
  }

  return form.policy ? form.policy.displayName : 'General Information';
};
